@use "vst-ui-kit/src/utils";
@use "../utils/routeFocus";
@use "../common/default-styles";

.page {
  min-width: 0;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  overflow: clip;

  // Fixes mid-size panel placement when the sidebar is turned off
  // The lack of page content seems to not play nice with the panel position: sticky
  min-height: calc(100dvh - var(--home-embedded-header-height));
}

.innerContentNoPanel {
  min-width: 0;
  flex-grow: 1;
  overflow: clip;
  position: relative;
  container: template-content / inline-size;
}

.primaryContent {
  margin: var(--home-inset);
  flex-grow: 1;

  // Has header stuff
  &:not(:first-child) {
    margin-top: 0;
  }

  @include default-styles.add-defaults;
  @include routeFocus.outline-focus(10px);

  &.tightFocus {
    @include routeFocus.outline-focus(-2px, 15px);
  }
}

// Remove default margin, useful for pages that require full-bleed effects
.noInset .primaryContent {
  margin: 0;
  // stylelint-disable-next-line length-zero-no-unit
  @include routeFocus.outline-focus(-2px, 0px);
}

.page:not(:has(.noInset)) {
  --panel-margin-start: 0;
}
